<template>
  <div
    class="offcanvas offcanvas-start up"
    tabindex="-1"
    id="userPanel"
    aria-labelledby="userPanelLabel"
  >
    <div class="up-header">
      <h5 class="up-title" id="userPanelLabel">Kullanıcı Bilgileri</h5>
      <button type="button" class="up-close" data-bs-dismiss="offcanvas" aria-label="Kapat">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="up-body">
      <div class="up-profile">
        <p class="up-greeting">Hoş geldiniz!</p>
        <div class="up-avatar" title="Profil resmi">
          <img :src="getProfilePicture" alt="" />
        </div>
        <p class="up-name">{{ getUserFullName }}</p>
        <p class="up-account">
          <span class="material-symbols-outlined">domain</span>
          {{ getAccountTitle }}
        </p>
      </div>

      <button class="btn vy-btn vy-btn-outline" type="button" @click="logout">
        <span class="material-symbols-outlined">logout</span>
        Çıkış Yap
      </button>

      <footer class="up-footer">İzometri Bilişim © {{ getYear() }}</footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "User",
  computed: {
    login() {
      return this.$root.$data.login;
    },
    getUserFullName() {
      if (this.login)
        return `${this.login.User?.FirstName} ${this.login.User?.LastName}`;

      return "N/A";
    },
    getAccountTitle() {
      if (this.currentAccount) return this.currentAccount.Title;

      return "N/A";
    },
    currentAccount() {
      return this.$root.$data.login.Account;
    },
    
  },
  methods: {
    getYear(){
      var currentYear = new Date()
      return currentYear.getFullYear();
    },
    logout() {
      //if (!confirm("Oturumunuz sonlandırılacak.")) return;
      this.$izonayConfirm("Oturumu kapatmak istediğinize emin misiniz?").then(
        (response) => {
          if (!response.isConfirmed) return;

          var externalIdentitySource =
            this.$root?.$data?.login?.User.ExternalIdentitySource;

          axios.post("/token/signout", {});
          this.$root.$data.login = null;
          window.localStorage.removeItem("user");
          axios.defaults.headers.common["token"] = "";
          this.$store.commit("setUser", null);

          if (externalIdentitySource)
            this.logoutExternalUser(externalIdentitySource);
          else this.$router.push({ name: "Login" });
        }
      );
    },
    logoutExternalUser(externalIdentitySource) {
      const pushToLogin = () => {
        this.$router.push({ name: "Login" });
      };

      switch (externalIdentitySource) {
        case "Microsoft":
          this.$msalSignOut();
          break;
        case "ADFS":
          this.$msalSignOut(true);
          pushToLogin();
          break;
        default:
          pushToLogin();
      }
    },
  },
};
</script>
<style scoped>
.up {
  width: min(320px, 85vw);
  border-radius: 0 16px 16px 0;
  background-color: #ffffff;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

.up-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 56px;
  margin-top: env(safe-area-inset-top, 0px);
  padding: 0 8px 0 20px;
  border-bottom: 1px solid #EFEFEF;
}

.up-title {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: #092154;
}

.up-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #092154;
  font-size: 24px;
}

.up-body {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: calc(100% - 56px - env(safe-area-inset-top, 0px));
  padding: 24px 20px calc(env(safe-area-inset-bottom, 0px) + 20px) 20px;
}

.up-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  text-align: center;
}

.up-greeting {
  margin: 0 0 16px 0;
  font-weight: 400;
  font-size: 13px;
  color: #808080;
}

.up-avatar {
  width: 88px;
  height: 88px;
  overflow: hidden;
  border: 3px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 0 4px #E9F4FF;
}

.up-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.up-name {
  margin: 16px 0 4px 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #092154;
}

.up-account {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 4px 12px;
  border-radius: 100px;
  background-color: #F1F7FF;
  font-weight: 500;
  font-size: 13px;
  color: #182F5E;
}

.up-account .material-symbols-outlined {
  font-size: 18px;
}

.up-footer {
  margin-top: auto;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #808080;
}
</style>
